import { MaintenancePlanActionCreate } from "@boark/shared/types/maintenance-plan-action-create";
import {
  MaintenancePlanAction,
  maintenancePlanActionSchema,
} from "@boark/shared/types/maintenance-plan-action";
import * as z from "zod";

import { deleteRequest, getRequest, postRequest } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getMaintenancePlanActions(
  maintenancePlanId: string,
): Promise<MaintenancePlanAction[]> {
  return getRequest(
    `${API_BASE_URL}/maintenance-plan/${maintenancePlanId}/action`,
    z.array(maintenancePlanActionSchema),
  );
}

export async function createMaintenancePlanAction(
  maintenancePlanId: string,
  action: MaintenancePlanActionCreate,
): Promise<MaintenancePlanAction> {
  return postRequest(
    `${API_BASE_URL}/maintenance-plan/${maintenancePlanId}/action`,
    action,
    maintenancePlanActionSchema,
  );
}

export async function deleteMaintenancePlanAction(
  maintenancePlanId: string,
  actionId: string,
): Promise<void> {
  return deleteRequest(
    `${API_BASE_URL}/maintenance-plan/${maintenancePlanId}/action/${encodeURIComponent(actionId)}`,
  );
}
